import React, {useEffect, useState} from "react";
import {Route, Routes, useLocation} from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import getAppRoutes from "app/routes";
import {useAppUIController} from "app/context/AppUIControllerProvider";
import {
    checkNullJson,
    checkNullStr,
    getBrowserCookie,
    getCurrUrlParamValue,
    getJsonValue,
    getDefStr,
    isBoolTrue,
    isValueBool
} from "../common/fusion-ui/utils/ReactUtils";
import {isCurrUrlOfAuthRoute, printError, printLog} from "./utils/AppUtils";
import {DEF_APP_THEME, Keys} from "./config/AppConfig";
import {useSubdomainData} from "./context/SubdomainProvider";
import {ThemeProvider} from "@mui/material";
import themeDark from "./assets/theme-dark";
import theme from "./assets/theme";
import {useAuth} from "./context/AuthProvider";
import {ProjectThemeProvider} from "../common/ProjectThemeProvider";
import {Toast} from "../common/fusion-ui";
import {clearAdminSessionData} from "../admin/utils/AdminUtils";
import {BypassTokenLoadingPanel} from "./index";
// import "../common/assets/css/ThemeStyles_RoyalBlue.css";
// import "../common/assets/css/ThemeStyles_Orchid.css";
// import "../common/assets/css/ThemeStyles_Dark.css";

export default function App() {
    const TAG = 'App.js';

    const location = useLocation();
    const {appTheme} = useSubdomainData();
    const [controller, dispatch] = useAppUIController();
    const {bypassTokenChecking, bypassTokenVerified, bypassTokenCheckMsg} = useAuth();
    const [themeCssLoadingData, setThemeCssLoadingData] = useState({loading: true, success: false, msg: 'Setting up...'});

    const {darkMode} = controller;

    const Fields = {
        lastUrl: 'lastUrl',
        isCssImported: 'isCssImported',
    };
    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        //Clear admin-session data
        clearAdminSessionData(null, true);

        // const wmAlloc = isModuleAllocated(Modules.WebMeeting);
        // const ppAlloc = isModuleAllocated(Modules.PeerProfiles);
        // const lglAlloc = isModuleAllocated(Modules.Legal);
        // log('useEffect.wmAlloc:', wmAlloc, ' | ppAlloc:', ppAlloc, ' | lglAlloc:', lglAlloc);
    }, []);
    useEffect(() => {
        importThemeCssFile();
    }, [appTheme]);

    return (
        <>
            <ProjectThemeProvider themeName={appTheme}>
                <ThemeProvider theme={darkMode ? themeDark : theme}>
                    <CssBaseline/>
                    {/*<DynamicCssLoader/>*/}
                    {/*<ConfiguratorButton/>*/}
                    {(isBypassTokenVerifying() || themeCssLoadingData.loading)
                        ? <BypassTokenLoadingPanel
                            // msg={bypassTokenCheckMsg}
                            // loading={bypassTokenChecking}
                            // success={bypassTokenVerified}
                            // loadingLabel={bypassTokenVerified ? '' : bypassTokenCheckMsg}
                            msg={(themeCssLoadingData.loading) ? themeCssLoadingData.msg : bypassTokenCheckMsg}
                            loading={themeCssLoadingData.loading || bypassTokenChecking}
                            success={themeCssLoadingData.success || bypassTokenVerified}
                            loadingLabel={(themeCssLoadingData.loading) ? themeCssLoadingData.msg : (bypassTokenVerified ? '' : bypassTokenCheckMsg)}
                            shadowVariant={themeCssLoadingData.loading ? 'none' : 'md'}
                        />
                        : <Routes>
                            {getAppRoutes(isCurrUrlOfAuthRoute(location)).map((item, index) => {
                                return (checkNullJson(item) && !isValueBool(item)) &&
                                    <Route key={item.route} exact path={item.route} element={item.component}/>
                            })}
                        </Routes>
                    }
                </ThemeProvider>
            </ProjectThemeProvider>
            <Toast/>
        </>
    )

    function importThemeCssFile() {
        const fun = 'importThemeCssFile:';
        if (!isFieldTrue(Fields.isCssImported)) {
            try {
                setThemeCssLoadingData({loading: true, success: false, msg: "Setting up..."});
                updateField(Fields.isCssImported, true);
                const themeName = getDefStr(appTheme, getDefStr(getBrowserCookie(Keys.theme), DEF_APP_THEME));
                // log(fun, 'appTheme:', appTheme, 'themeName:', themeName);

                import(`../common/assets/css/ThemeStyles_${themeName}.css`)
                    .then(() => {
                        setThemeCssLoadingData({loading: false, success: true, msg: "Setup complete."});
                        // log(`'${themeName}' CSS file loaded`)

                        // importLightDarkThemeCssFile();
                    })
                    .catch((error) => {
                        import(`../common/assets/css/ThemeStyles_RoyalBlue.css`);
                        setThemeCssLoadingData({loading: false, success: false, msg: "Setup failed!"});
                        logErr(`Error loading '${themeName}' theme CSS file:`, error);
                        // importLightDarkThemeCssFile();
                    });
            } catch (error) {
                updateField(Fields.isCssImported, true);
                setThemeCssLoadingData({loading: false, success: false, msg: "Setup failed!"});
                logErr(fun, error);
                // importLightDarkThemeCssFile();
            }
        }
    }

    function isBypassTokenVerifying() {
        const tokenFound = checkNullStr(getCurrUrlParamValue(Keys.urlParam_loginBypassTokenAlias));
        let verifying = false;
        if (tokenFound) {
            // verifying = bypassTokenChecking;
            verifying = bypassTokenChecking || !bypassTokenVerified;
        }
        return verifying;
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
}
